import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { feedbackPendingsActions } from '../actions/feedback-pendings.actions';
import {
    selectFeedbackLearningPathPendings,
    selectFeedbackLearningPathPendingsDismissing,
    selectFeedbackLearningPathPendingsLoading,
} from '../selectors/feedback-pendings.selectors';

@Injectable({
    providedIn: 'root',
})
export class FeedbackPendingsFacade {
    private readonly store = inject(Store);

    readonly learningPathPendings$ = this.store.select(selectFeedbackLearningPathPendings);
    readonly learningPathPendingsLoading$ = this.store.select(selectFeedbackLearningPathPendingsLoading);
    readonly learningPathPendingsDismissing$ = this.store.select(selectFeedbackLearningPathPendingsDismissing);

    getLearningPathPendings() {
        this.store.dispatch(feedbackPendingsActions.getLearningPathPendings());
    }

    dismissLearningPathPendings() {
        this.store.dispatch(feedbackPendingsActions.dismissLearningPathPendings());
    }
}
